@if (events?.length) {
    <ngb-carousel
        [activeId]="startEventId"
        [showNavigationArrows]="events.length > 1"
        [showNavigationIndicators]="events.length > 1">
        @for (e of events; track e.Id) {
            <ng-template ngbSlide [id]="e.Id">
                <app-spotlight [event]="e"></app-spotlight>
            </ng-template>
        }
    </ngb-carousel>
}
